import { jsx as _jsx } from "preact/jsx-runtime";
import { getNotices } from '@basket/store/actions/notices';
import { useBasketSelector } from '@basket/store/hooks';
import Notice from '@basket/components/Notice';
function Notices() {
    const notices = useBasketSelector(getNotices);
    if (!notices || !notices.length) {
        return null;
    }
    return (_jsx("div", { className: "notices", children: notices.map(Notice) }));
}
export default Notices;
